module.exports = __webpack_public_path__ + "static/media/icon-like.6e3de140.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-like.svg
// module id = 534
// module chunks = 0